import { Component,OnInit } from '@angular/core';
import {LanguageService} from "./providers/lang.service";
import { Entity, Todo } from './providers/entity';
@Component({
  selector: 'app-root',
  template: `

      <router-outlet></router-outlet>
  
  `,
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'app works!';
  value:any;
  constructor(private languageservice: LanguageService) { }


   ngOnInit(){
   this.languageservice.getLanguageData();

   }
  
}





// WEBPACK FOOTER //
// ./src/app/app.component.ts